// extracted by mini-css-extract-plugin
export default {"replies_table":"Dashboard_replies_table__X+Pvm","tiles":"Dashboard_tiles__Iz4WG","tileheader":"Dashboard_tileheader__z-Zc5","metricTile":"Dashboard_metricTile__zL7TS"};